import React from 'react';
import ReactDOM from 'react-dom';
import { Root } from 'Root';
import { createHashHistory } from 'history';
import * as Sentry from '@sentry/react';
import { Button } from 'm-ui';
import './index.less';
import { init } from '@i18n/uc';
import { System, init as JumpInit } from '@i18n/kwai-i18n-ad-jump-fe';
// import devtools from 'devtools-detect';

export const history = createHashHistory();

init({
    curServerKey: System.creativePortal,
    needSource: true,
});

// 雷达上报 跳转链接
JumpInit({
    isAddSource: true,
    jumpOptionFn(error, option) {
        if (!error && option) {
            // const { source } = option;
            // weblogger.plugins.radar.event({
            //     name: '来源页上报', // 必填
            //     extra_info: JSON.stringify({
            //         source,
            //         curPath: window.location.href,
            //     }),
            // });
        }
    },
});

// console.log('devtools==========>', devtools);

// if (devtools.isOpen) {
//     console.log('当控制台开启 进入系统  上报');
// }

// window.addEventListener('devtoolschange', (event) => {
//     if (event.detail.isOpen) {
//         console.log('监听 devtoolschange 上报');
//     }
// });

ReactDOM.render(
    <Sentry.ErrorBoundary
        fallback={({ error, componentStack, resetError }) => (
            <>
                <div>You have encountered an error</div>
                <div>{error.message}</div>
                <div>{componentStack}</div>
                <Button
                    onClick={() => {
                        resetError();
                    }}
                >
                    Click here to reset!
                </Button>
            </>
        )}
    >
        <Root />
    </Sentry.ErrorBoundary>,
    document.getElementById('root'),
);
